import { createI18n } from 'vue-i18n';

import en from './locales/en.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import zh from './locales/zh.json';

export const LOCALES = [
  { code: 'it', label: 'Italiano' },
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'zh', label: '简体中文' },
];

const SUPPORTED = new Set(LOCALES.map((l) => l.code));

export function detectLocale() {
  const saved = localStorage.getItem('bacheca.locale');
  if (saved && SUPPORTED.has(saved)) return saved;
  for (const preferred of navigator.languages ?? [navigator.language]) {
    const code = String(preferred).split('-')[0];
    if (SUPPORTED.has(code)) return code;
  }
  return 'en';
}

export default createI18n({
  // Composition API: `legacy: true` esiste solo per compatibilità con Vue 2.
  legacy: false,
  globalInjection: true,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: { en, it, fr, zh },
});
